import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const FileUploadCard = ({
  files,
  setUploadedFiles,
  handleUpload,
  id,
  fileSelectionType,
  disabled,
  fullWidth,
}) => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const handleFileChange = async (event) => {
    const selectedFiles = event.target.files;
    console.log('Selected files:', selectedFiles);

    if (selectedFiles && Array.from(selectedFiles).length > 0) {
      const newUploadedFiles = [...files];

      setIsUploading(true);
      try {
        for (const file of selectedFiles) {
          setFile(file);
          const fileData = await handleUpload(file, id);
          newUploadedFiles.push(fileData);
        }
      } catch (error) {
        console.log('Error uploading file:', error);
      } finally {
        setIsUploading(false);
        setUploadedFiles(newUploadedFiles);
      }
    }
  };

  return (
    <div className={fullWidth ? '' : 'col-lg-3 col-md-4 col-sm-12'}>
      <div
        className="card"
        style={{
          marginBottom: 0,
          height: '100%',
          borderRadius: 12,
          justifyContent: 'space-between',
        }}
      >
        <div className="file">
          <label
            htmlFor="file-upload"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '120px',
              border: '2px dashed gray',
              borderRadius: '10px',
              cursor: 'pointer',
            }}
          >
            <i
              className="fa fa-plus"
              style={{ fontSize: '24px', color: 'gray' }}
            ></i>
            <span style={{ marginTop: '10px', color: 'gray' }}>
              Upload File
            </span>
            <input
              id="file-upload"
              type="file"
              multiple
              accept={!fileSelectionType ? '/*' : fileSelectionType}
              style={{ display: 'none' }}
              disabled={isUploading || disabled}
              onChange={handleFileChange}
            />
          </label>

          <div
            className="file-name mt-3 text-center"
            style={{ marginTop: '10px', textAlign: 'center' }}
          >
            <p className="m-b-5 text-muted">
              {file ? file.name : 'No file selected'}
            </p>
            {file && (
              <small>
                Size: {(file.size / 1000000).toFixed(2)} MB{' '}
                <span className="date text-muted">
                  {new Date().toLocaleDateString()}
                </span>
              </small>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

FileUploadCard.propTypes = {
  files: PropTypes.arrayOf(PropTypes.instanceOf(File)), // array of File instances
  setFiles: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

const mapStateToProps = ({ mailInboxReducer, analyticalReducer }) => ({});

export default connect(mapStateToProps, {})(FileUploadCard);
